import { useContext } from 'react'
import { Navigate, Outlet } from 'react-router'
import UserContext from 'shared/contexts/UserContext'
import LsAdminCertificateInfos from './LsAdminCertificateInfos'
import LsAdminConfigurations from './LsAdminConfigurations'
import LsAdminCreateConfiguration from './LsAdminCreateConfiguration'
import LsAdminCreateCredential from './LsAdminCreateCredential'
import LsAdminCreateIbtContracts from './LsAdminCreateIbtContracts'
import LsAdminCreateLocationAttributes from './LsAdminCreateLocationAttributes'
import LsAdminCredentials from './LsAdminCredentials'
import LsAdminEditCredential from './LsAdminEditCredential'
import { LsAdminIbtContracts } from './LsAdminIbtContracts'
import LsAdminLocationAttributes from './LsAdminLocationAttributes'

const LoadSchedulingAdminWrapper = () => {
  const { availableToolPolicies } = useContext(UserContext)
  const isAdmin = availableToolPolicies.includes('system:admin')
  return isAdmin ? <Outlet /> : <Navigate to="/not-authorised" replace />
}

export const routes = [
  {
    title: 'Load Scheduling Admin',
    key: 'load-scheduling-admin-configs',
    path: '/load-scheduling/configs',
    main: <LoadSchedulingAdminWrapper />,
    childRoutes: [
      {
        title: 'Load Scheduling Admin Configurations',
        key: 'ls-admin-config',
        entryPoint: true,
        main: <LsAdminConfigurations />,
        path: '/',
      },
      {
        title: 'Load Scheduling Admin Create Configuration',
        key: 'ls-admin-create-config',
        main: <LsAdminCreateConfiguration />,
        path: '/create',
      },
    ],
  },
  {
    title: 'Load Scheduling Admin',
    key: 'load-scheduling-admin-credentials',
    path: '/load-scheduling/credentials',
    main: <LoadSchedulingAdminWrapper />,
    childRoutes: [
      {
        title: 'Load Scheduling Admin Credentials',
        key: 'ls-admin-credentials',
        main: <LsAdminCredentials />,
        path: '/',
        entryPoint: true,
      },
      {
        title: 'Load Scheduling Admin Create Credential',
        key: 'ls-admin-create-credential',
        main: <LsAdminCreateCredential />,
        path: '/create',
      },
      {
        title: 'Load Scheduling Admin Edit Credential',
        key: 'ls-admin-edit-credential',
        main: <LsAdminEditCredential />,
        path: '/edit/:credentialId',
      },
    ],
  },
  {
    title: 'Load Scheduling Admin',
    key: 'load-scheduling-admin-location-attributes',
    path: '/load-scheduling/location-attributes',
    main: <LoadSchedulingAdminWrapper />,
    childRoutes: [
      {
        title: 'Load Scheduling Admin Location Attributes',
        key: 'ls-admin-location-attributes',
        main: <LsAdminLocationAttributes />,
        entryPoint: true,
        path: '/',
      },
      {
        title: 'Load Scheduling Admin Create Location Attributes',
        key: 'ls-admin-location-create-attributes',
        main: <LsAdminCreateLocationAttributes />,
        path: '/create',
      },
    ],
  },
  {
    title: 'Load Scheduling Admin',
    key: 'load-scheduling-admin-ibt-contracts',
    path: '/load-scheduling/ibt-contracts',
    main: <LoadSchedulingAdminWrapper />,
    childRoutes: [
      {
        title: 'Load Scheduling Admin Internal Bilateral Transfer Contracts',
        key: 'ls-admin-ibt-contracts',
        main: <LsAdminIbtContracts />,
        entryPoint: true,
        path: '/',
      },
      {
        title:
          'Load Scheduling Admin Create Internal Bilateral Transfer Contracts',
        key: 'ls-admin-location-create-ibt-contracts',
        main: <LsAdminCreateIbtContracts />,
        path: '/create',
      },
    ],
  },
  {
    title: 'Load Scheduling Admin',
    key: 'load-scheduling-admin-certs-info',
    path: '/load-scheduling/certificate-information',
    main: <LoadSchedulingAdminWrapper />,
    childRoutes: [
      {
        title: 'Load Scheduling Admin Certificate Information',
        key: 'ls-admin-certs-info',
        main: <LsAdminCertificateInfos />,
        entryPoint: true,
        path: '/',
      },
    ],
  },
]
